<label [for]="id" class="label-wrapper">
  <ng-content select="[styledCheckbox]"></ng-content>
  <span [ngClass]="id ? 'control-label-text' : 'no-control-label-text'" [class.yes-no]="question?.type === 'yesnotoggle'" [innerHTML]="question?.label | safeHtml:'label'"></span>
  @if (flow && question?.visible()) {
    <span class="margin-left control-label-icon-container">
      <help-text [question]="question" [position]="i === 0 ? 'bottom' : 'top'"></help-text>
      @if (flow.canShowNote(question)) {
        <svg-icon class="note-icon cursor-pointer" [ngClass]="{'minor-margin-left' : question.helpText}"
        [icon]="flow.getNoteIcon(question.contextTarget)" (click)="addNote($event)" ></svg-icon>
      }
      @if (requiresNotes) {
        <help-text [alert]="true" [helpText]="'Prior to editing, this field requires a note to be created the same day.'"></help-text>
      }
    </span>
  }
</label>